// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { borderRadius } from 'polished';

import { MaterialIcon } from '../MaterialIcon';
import { CloseTapTarget } from '../CloseTapTarget';

const HeaderContainer = styled(({ borderless, ...rest }) => <div {...rest} />)`
    background-color: ${(props) => props.theme.colors.background.default};
    ${(props) => !props.borderless && `border-bottom: 1px solid ${props.theme.colors.border.default}`};
    ${borderRadius(`top`, (props) => props.theme.constants.corner)};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.337rem;
`;

const HeaderLabel = styled(({ ...rest }) => <h3 {...rest} />)`
    color: ${(props) => props.theme.colors.text.default};
    font-family: ${(props) => props.theme.typography.fonts.ui};
    font-size: 1.066rem;
    font-weight: 600;
    line-height: 1.337rem;
    margin: 0;
    min-width: 10rem;
`;

export const DialogHeader = ({ children, close, ...props }) => {
    const a11yProps = {};

    return (
        <HeaderContainer {...a11yProps} {...props}>
            {typeof children === 'string' ? <HeaderLabel>{children}</HeaderLabel> : children}
            {typeof close === 'function' && (
                <CloseTapTarget onClick={close}>
                    <MaterialIcon icon="close" size={18} />
                </CloseTapTarget>
            )}
        </HeaderContainer>
    );
};

DialogHeader.propTypes = {
    /**
     * Defines if a border below the header should be rendered.
     */
    borderless: PropTypes.bool,
    /**
     * Children node(s) to be rendered.
     */
    children: PropTypes.node,
    /**
     * A function to dismiss the dialog/modal.
     *
     * If defined, a close button will be rendered.
     */
    close: PropTypes.func
};

DialogHeader.defaultProps = {
    borderless: false
};
